import { usePassThrough } from 'primevue/passthrough';

export const preset = usePassThrough(
  {
    pcpaginator: {
      root: {
        class: 'datatable-pagination',
      },
    },
    tablecontainer: {
      class: 'datatable-container',
    },
    filterelementcontainer: {
      root: {
        class: 'datatable-cell',
      },
    },
  },
  {
    mergeSections: true,
    mergeProps: false,
  },
);

export const primevueConfig = {
  unstyled: true,
  pt: preset,
};
